import React from "react";
import { useIntl } from "react-intl";
import { useMutation } from "react-query";
import { useSnackbar } from "notistack";
import { ClickAwayListener, IconButton } from "@mui/material";
import FileCopyIcon from "@mui/icons-material/FileCopy";

import { FilterGroup, createGroup } from "../../services/Alert";
import { NameInputMenu } from "../Filter/NameInputMenu";
import { ActionTooltip } from "../../components/Tooltips";

export const FilterGroupCreate = ({
  group,
  onCreate,
  moduleSlug,
}: {
  group: FilterGroup;
  onCreate: (newGroup: FilterGroup) => void;
  moduleSlug?: string;
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const intl = useIntl();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const mutation = useMutation<FilterGroup, Error, Omit<FilterGroup, "id">>(
    (group: Omit<FilterGroup, "id">) => createGroup(group),
    {
      onSuccess: (data) => {
        onCreate(data);
        setOpen(false);
        enqueueSnackbar(
          intl.formatMessage({ id: "GROUP_SUCCESSFULLY_CREATED" }),
          {
            variant: "success",
          }
        );
      },
    }
  );

  const handleSubmit = (name: string) => {
    // We remove the id before we create
    const { id, ...newGroup } = {
      ...group,
      name,
      module: moduleSlug,
      favorite: false,
      readonly: false,
    } as any;
    mutation.mutate(newGroup);
  };

  return (
    <>
      <ClickAwayListener
        onClickAway={() => setOpen(false)}
        mouseEvent="onMouseDown"
      >
        <div>
          <ActionTooltip title={"DUPLICATE"}>
            <IconButton
              sx={{ color: "text.accentInverted" }}
              onClick={() => setOpen((prevOpen) => !prevOpen)}
              ref={anchorRef}
              size={"small"}
            >
              <FileCopyIcon fontSize="small" />
            </IconButton>
          </ActionTooltip>
          <NameInputMenu
            anchorEl={anchorRef.current}
            error={mutation.error}
            onClose={() => setOpen(false)}
            onSubmit={handleSubmit}
            open={open}
            value={group.name}
          />
        </div>
      </ClickAwayListener>
    </>
  );
};
